var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-overlay',{attrs:{"z-index":999999,"value":_vm.show}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#FFD600","width":"6","size":"64"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }